import { useQuery } from '@tanstack/react-query'

import { useAuth } from 'pkg/authentication'

import Client from 'utils/client'

const GET_URI = 'v1/user/tags'


export default function useUserTagsQuery() {
  const { user } = useAuth()

  const queryKey = ['user', user.id, 'tags']

  const {
    data = {},
    ...rest
  } = useQuery({
    queryFn: () => Client.get(GET_URI),
    queryKey,
    refetchOnWindowFocus: false,
  })

  const userTags = data.data?.tags

  return {
    ...rest,
    userTags,
  }
}
